import type { FixedFooterProps } from "./interface";
import { useFixedFooter } from "./useFixedFooter";

export function FixedFooter({ children, pageRef }: FixedFooterProps) {
  const { footerRef } = useFixedFooter(children, pageRef);

  return (
    <div
      ref={footerRef}
      className="flex flex-col gap-4 fixed bottom-0 left-0 right-0 border-t border-[#D8DCDE] p-4 bg-white z-50 shadow-lg"
    >
      {children}
    </div>
  );
}
